<div>
  <section class="sessao-titulo">
    <div>
      <p class="titulo">Fale conosco!</p>
      <p class="subtitulo">
        Converse com a nossa equipe pelo WhatsApp, Instagram ou Facebook.
      </p>
    </div>
  </section>
  <section class="sessao-contatos">
    <hr class="mr-5 ml-5 p-3" />
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm" *ngFor="let contato of contatos">
          <div class="botao-icones">
            <a [href]="contato.href" [class]="contato.class" target="_blank">
              <i [class]="contato.icon"></i>
            </a>
          </div>
          <div class="fonte-icone">
            <a [href]="contato.href" class="btn btn-link link" target="_blank">
              {{ contato.text }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr class="mr-5 ml-5 p-3" />
  </section>
</div>
